export enum UserRole {
  SITECORDINATOR = 'sitecoordinator'
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending'
}

export enum UserProfileStatus {
  COMPLETED = 'completed',
  INCOMPLETED = 'incompleted'
}

export const ROLE_BASE_ROUTE: Record<UserRole, string> = {
  [UserRole.SITECORDINATOR]: '/site-coordinator'
};

export interface UiOption<T = string> {
  value: T;
  label: string;
}

export const USER_ROLE_OPTIONS: UiOption<UserRole>[] = [
  { value: UserRole.SITECORDINATOR, label: 'Site Coordinator' },
];